import React, {FC, Fragment} from 'react';
import {InputNumber} from 'antd';
import {withFormItem} from "../FormItem";
import {JNumberProps} from "../../models";
export const JNumberWithoutFormItem: FC<JNumberProps> = (props) => {
    return (
        <InputNumber
            onChange={props.onChange}
            type={'number'}
            disabled={props.disabled}
            placeholder={props.placeholder}
            aria-describedby={props.validationMessage}
            value={props.value as unknown as number}
        />
    )
}
export const JNumberDefault: FC<JNumberProps> = withFormItem(JNumberWithoutFormItem)

export const JNumber: FC<JNumberProps> = (props) => {
    return (
        <Fragment>
            <JNumberDefault {...props} />
        </Fragment>
    )
}